import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "filter-header" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  class: "filters",
  id: "filter-tab-external-content"
}
const _hoisted_4 = { class: "radio-group" }
const _hoisted_5 = ["value"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Filter by Region", -1 /* HOISTED */)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "sales-contact-listing" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "region-group-title" }
const _hoisted_11 = { class: "region" }
const _hoisted_12 = { class: "contacts" }
const _hoisted_13 = { class: "sales-contact" }
const _hoisted_14 = { class: "rep-name" }
const _hoisted_15 = {
  key: 0,
  class: "sales-contact-state"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("strong", null, "USA", -1 /* HOISTED */)
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 1,
  class: "sales-contact-email"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  class: "svg-icon text-info",
  "aria-label": "Email"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/frontend/dist/svg-icons/icons.svg#email" })
], -1 /* HOISTED */)
const _hoisted_20 = ["href"]
const _hoisted_21 = {
  key: 2,
  class: "sales-contact-phone"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("svg", {
  class: "svg-icon text-info",
  "aria-label": "Phone"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/frontend/dist/svg-icons/icons.svg#phone" })
], -1 /* HOISTED */)
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = {
  key: 3,
  class: "sales-contact-mobile"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("svg", {
  class: "svg-icon text-info",
  "aria-label": "Mobile"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/frontend/dist/svg-icons/icons.svg#phone" })
], -1 /* HOISTED */)
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clearfix" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.populatedRegionGroups, (regiongroup) => {
              return (_openBlock(), _createElementBlock("label", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.changeSelectedRegionGroup()))
              }, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedRegionGroup) = $event)),
                  type: "radio",
                  value: regiongroup.code,
                  id: "regiongroup-{{regiongroup.code}}",
                  name: "selectedRegionGroup",
                  onChange: _cache[1] || (_cache[1] = ($event: any) => ($options.changeSelectedRegionGroup()))
                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_5), [
                  [_vModelRadio, _ctx.selectedRegionGroup]
                ]),
                _createTextVNode(" " + _toDisplayString(regiongroup.name), 1 /* TEXT */)
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedRegion) = $event)),
              id: "contactsSelectedRegion",
              class: "form-control form-select",
              onChange: _cache[4] || (_cache[4] = ($event: any) => ($options.updateFilters()))
            }, [
              _hoisted_6,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredRegionsByRegionGroup, (region) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: region.code
                }, _toDisplayString(region.name), 9 /* TEXT, PROPS */, _hoisted_7))
              }), 256 /* UNKEYED_FRAGMENT */))
            ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [_vModelSelect, _ctx.selectedRegion]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regiongroups.filter(r => r.code == _ctx.selectedRegionGroup), (regiongroup) => {
          return (_openBlock(), _createElementBlock("h4", _hoisted_10, _toDisplayString(regiongroup.title), 1 /* TEXT */))
        }), 256 /* UNKEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredRegions, (region) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("h5", null, _toDisplayString(region.name), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(region.contacts, (contact) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("h6", _hoisted_14, _toDisplayString(contact.name), 1 /* TEXT */),
                  (contact.state != '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("p", null, [
                          _hoisted_16,
                          _createTextVNode(": " + _toDisplayString(contact.state), 1 /* TEXT */)
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", {
                    class: "sales-contact-territory",
                    innerHTML: contact.territory
                  }, null, 8 /* PROPS */, _hoisted_17),
                  (contact.email != '')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                        _hoisted_19,
                        _createTextVNode(),
                        _createElementVNode("a", {
                          class: "link-info",
                          href: `mailto:${contact.email}`
                        }, _toDisplayString(contact.email), 9 /* TEXT, PROPS */, _hoisted_20)
                      ]))
                    : _createCommentVNode("v-if", true),
                  (contact.phone != '')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                        _hoisted_22,
                        _createTextVNode(),
                        _createElementVNode("span", {
                          innerHTML: $options.phoneToLink(contact.phone)
                        }, null, 8 /* PROPS */, _hoisted_23)
                      ]))
                    : _createCommentVNode("v-if", true),
                  (contact.mobile != '')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                        _hoisted_25,
                        _createTextVNode(),
                        _createElementVNode("span", {
                          innerHTML: $options.phoneToLink(contact.mobile)
                        }, null, 8 /* PROPS */, _hoisted_26)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ])
          ]))
        }), 256 /* UNKEYED_FRAGMENT */)),
        _hoisted_27
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}